module.exports = __webpack_public_path__ + "img/account-group-black.201a2d53.svg";